document.addEventListener('DOMContentLoaded', function () {
    // For description & Grade on PDP
    function scrollAndOpenTab({
    triggerSelector,
    scrollTargetSelector,
    tabSelector,
    tabText
    }) {
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest(triggerSelector);
        if (!trigger) return;

        e.preventDefault();

        // Scroll to section
        const scrollTarget = document.querySelector(scrollTargetSelector);
        if (scrollTarget) {
        scrollTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        }

        // Activate tab
        let tab = null;

        if (tabSelector) {
        tab = document.querySelector(tabSelector);
        } else if (tabText) {
        tab = [...document.querySelectorAll('.tabs__item-label')]
            .find(el => el.textContent.trim().includes(tabText));
        }

        if (tab) tab.click();
    });
    }

    scrollAndOpenTab({
    triggerSelector: '#grade_info',
    scrollTargetSelector: '#tabs__content_product',
    tabText: 'Grade'
    });
    scrollAndOpenTab({
    triggerSelector: '#description_info',
    scrollTargetSelector: '#tabs__content_product',
    tabText: 'description'
    });

    // After Pay on PDP
    // document.querySelectorAll('.after_pay_link').forEach(function (link) {
    //     link.addEventListener('click', function (e) {
    //         e.preventDefault();

    //         var modal = document.querySelector('afterpay-modal');
    //         if (modal) {
    //         modal.setAttribute('visible', 'visible');

    //         modal.setAttribute('data-modal-id', '');
    //         modal.setAttribute('data-locale', 'en_NZ');
    //         modal.setAttribute('data-modal-theme', 'mint');
    //         modal.setAttribute('data-apr-loans-available', 'false');
    //         modal.setAttribute('data-brand-name', 'afterpay');
    //         }
    //     });
    // });

    // Add on Product on PDP
    function techupProtectDetails(){
        const interval_ = setInterval(() => {
          const optionContainer = document.querySelector('.easify-product-options .tpo_option-set-container .tpo_option-container');
          if (optionContainer ) {
              clearInterval(interval_);

            if (optionContainer && !document.querySelector('#custom-techup-protect')) {
              const newDiv = document.createElement('div');
              newDiv.id = 'custom-techup-protect';
              newDiv.innerHTML = `
                <div class="tooltip-wrapper">
                  <span class="tooltip-icon">Details</span>
                  <div class="tooltip-content">
                    <ul>
                      <li><strong class="ql-size-small">12 Months + 1 Year Extended Warranty </strong></li>
                      <li><strong class="ql-size-small">Free Postage for approved claims</strong></li>
                      <li><strong class="ql-size-small" style="color: rgb(0, 0, 0);">Damaged your device? Don't worry, we've got you covered!&nbsp;(Additional charges apply)</strong></li>
                      <li><strong class="ql-size-small">Hassle-Free Process with Quick Resolutions</strong></li>
                      <li><strong class="ql-size-small">&#xFEFF;</strong><a href="https://techup.nz/pages/techup-care-terms-of-service" rel="noopener noreferrer" target="_blank" class="ql-size-small"><strong><u>Click Here for Detailed T&amp;C's</u></strong></a></li>
                    </ul>
                  </div>
                </div>
              `;
            
              // ✅ Insert AFTER .tpo_option-container
              optionContainer.insertAdjacentElement('afterend', newDiv);
            }
          }
        }, 200);
      }

      techupProtectDetails();

    //   For Tech Protect Details
      document.addEventListener('click', function (e) {
        const tooltip = e.target.closest('.tooltip-wrapper');
        document.querySelectorAll('.tooltip-wrapper').forEach(t => {
          if (t !== tooltip) t.classList.remove('active');
        });
        if (tooltip) tooltip.classList.toggle('active');
      });

    // Add active class to tabs on PDP
    function setFirstTabActive() {
      const tabLists = document.querySelectorAll(
        '#tabs__content_product .tabs__title-list__content'
      );

      tabLists.forEach(tabList => {
        const firstLi = tabList.querySelector('li');
        if (firstLi && !tabList.querySelector('li.active')) {
          firstLi.classList.add('active');
        }
      });
    }

    // Run on initial load
    setFirstTabActive();

    // Run again after Shopify section load (VERY IMPORTANT)
    document.addEventListener('shopify:section:load', setFirstTabActive);
    document.addEventListener('click', function (e) {
      const tabLabel = e.target.closest('#tabs__content_product .tabs__item-label');
      if (!tabLabel) return;

      const tabList = tabLabel.closest('#tabs__content_product .tabs__title-list__content');
      if (!tabList) return;

      // Remove active class from all <li>
      tabList.querySelectorAll('li').forEach(li => {
        li.classList.remove('active');
      });

      // Add active class to clicked <li>
      const parentLi = tabLabel.closest('li');
      if (parentLi) {
        parentLi.classList.add('active');
      }
    });

    // Sold Out Count On mobile PDP
    const interval1_ = setInterval(() => {
      const optionContainer = document.querySelector('.template-product  .soldcount-container');
      const targetEl = document.querySelector('.template-product .product__title');

      if (optionContainer && targetEl) {
        clearInterval(interval1_);
        targetEl.insertAdjacentHTML(
          'beforeend',
          optionContainer.innerHTML
        );
      }
    }, 200);


  // check TechUp Protect
  let techProtectAdded = false;
  function checktechupProtect() {
      document.querySelectorAll('.cart-items tr.cart-item').forEach((item) => {
        // Find addon/order estimation label safely
        const orderDt = item.querySelector(
          '.cart-item__details dl .product-option dt'
        );

        if (!orderDt) return;

        const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

      // Match your condition
      if (/techup protect/i.test(text)) {
         techProtectAdded = true;
        // item.querySelector('cart-remove-button button').click();
      }
    });
  }


  function removeMainAndAddonSafely(btn) {
    console.log('remove function call');

    const cartItem_ = btn.closest('tr.cart-item');
    if (!cartItem_) return;

    const removeButton = cartItem_.querySelector('cart-remove-button');
    if (!removeButton) return;

    const mainLineIndex = Number(removeButton.dataset.index);

    const cartItems_ =
      cartItem_.closest('cart-items') ||
      cartItem_.closest('cart-drawer-items');

    if (!cartItems_ || !cartItems_.updateQuantity) return;

    cartItems_.updateQuantity(mainLineIndex, 0);

    //  Read addon variant ID BEFORE removal
    let addonVariantId = null;

    const addonAttr =
      cartItem_.dataset.tpoAddOnVariantIds ||
      cartItem_.getAttribute('data-tpo-add-on-variant-ids');

    if (addonAttr) {
      try {
        addonVariantId = JSON.parse(addonAttr)[0];
      } catch (e) {
        addonVariantId = addonAttr;
      }
    }

    const allCartItems = cartItems_.querySelectorAll('.cart-item');

    let addonLineIndex = null;

    allCartItems.forEach(item => {
      const input = item.querySelector('input[name="updates[]"]');
      if (!input) return;

      if (input.dataset.quantityVariantId === addonVariantId) {
        addonLineIndex = Number(input.dataset.index);
      }
    });

    /* ---------- Remove ADD-ON first ------------ */
    setTimeout(function(){
      if (addonLineIndex !== null) {
        cartItems_.updateQuantity(addonLineIndex, 0);
      }
    },200)
    
  }

  // Save for later on Cart
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.swym-save-for-later-btn');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const productId = btn.dataset.productId;
    const productUrl = btn.dataset.productUrl;

    if (!window._swat) return;

    // Prevent double click
    if (btn.classList.contains('is-saved')) return;

    window._swat.addToWishList({
      epi: Number(variantId),
      empi: Number(productId),
      du: productUrl
    }, function () {

      // ✅ Update button UI
      btn.textContent = 'Saved';
      btn.classList.add('is-saved');
      btn.setAttribute('disabled', 'true');

      setTimeout(() => {

          //checktechupProtect();

          // Remove item using Shopify's CartItems logic
          const cartItem = btn.closest('tr.cart-item');
          if (!cartItem) return;


          const orderDt = cartItem.querySelector(
                '.cart-item__details dl .product-option dt'
              );

          if (!orderDt) return;

          const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

          // Match your condition
          if (/techup protect/i.test(text)) {
            techProtectAdded = true;
          }

          const removeButton = cartItem.querySelector('cart-remove-button');
          if (!removeButton) return;

          const lineIndex = Number(removeButton.dataset.index);

          const cartItems =
            cartItem.closest('cart-items') ||
            cartItem.closest('cart-drawer-items');

          if (!cartItems || !cartItems.updateQuantity) return;

          cartItems.updateQuantity(lineIndex, 0);

          if(techProtectAdded){
            removeMainAndAddonSafely(btn);
          }
          
          updateCartCount();

      }, 1000); 


    });


  });

  // Update cart total count
  function updateCartCount(){
    setTimeout(function(){
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        console.log(cart.item_count);
        if(document.getElementById('cart_count')){
          document.getElementById('cart_count').innerHTML = `${cart.item_count} <span>items</span>`;
        }
      });
    },1500);
  }

  function updateCartCountFromCart(cartData) {
    const cartCountEl = document.getElementById('cart_count');
    if (!cartCountEl) return;

    cartCountEl.innerHTML = `${cartData.item_count} <span>items</span>`;
  }

  document.addEventListener('afterUpdateQuantity', function (e) {
    if (!e.detail || !e.detail.cartData) return;
    console.log('afterUpdateQuantity');
    updateCartCountFromCart(e.detail.cartData);
  });

  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('afterCartChanged', updateCartCount);

  document.addEventListener('afterCartChanged', function (e) {
    if (!e.detail || !e.detail.cartData) return;
    console.log(e);
    updateCartCount();
  });

  // ESTIMATE DELIVERY WIDGET ON CART DRAWER & CART Page
  function getFirstOrderEstimationDD() {
    const firstCartItem = document.querySelector('.cart-item');
    if (!firstCartItem) return null;
    if (!firstCartItem.querySelector('.tpo_cart-properties-wrapper .product-option dd')) return null;
    return firstCartItem.querySelector('.tpo_cart-properties-wrapper .product-option dd');
  }

  const DELIVERY_ICONS = {
    'Order Confirmed': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img136.gif',
    'Shipped': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img135.gif',
    'At Your Doorstep': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img133.gif'
  };

  function parseOrderEstimation(dd) {
    const text = dd.innerText.replace(/\s+/g, ' ').trim();

    const heading = (text.match(/Estimated Delivery Date\s*(.*?)\s*Order Confirmed/i) || [])[1];

    const steps = [
      ['Order Confirmed', (text.match(/Order Confirmed\s*(.*?)\s*Shipped/i) || [])[1]],
      ['Shipped', (text.match(/Shipped\s*(.*?)\s*At Your Doorstep/i) || [])[1]],
      ['At Your Doorstep', (text.match(/At Your Doorstep\s*(.*)$/i) || [])[1]],
    ].filter(i => i[1]);

    return {
      heading,
      steps: steps.map(step => [
        step[0],
        step[1],
        DELIVERY_ICONS[step[0]]
      ])
    };
  }

  function createStepHTML(label, date, image) {
    return `
      <div class="delivery_step_wrap">
        <div class="delivery_step">
          <div class="step-icon"></div>
          <div class="three_step_card_img">
            <img 
              src="${image}" 
              alt="${label}" 
              loading="lazy"
            >
          </div>
        </div>
        <p class="step-date">
          ${label} <span>${date}</span>
        </p>
      </div>
    `;
  }

  function renderDeliveryTimeline() {
    const dd = getFirstOrderEstimationDD();
    if (!dd) return false;

    const parsed = parseOrderEstimation(dd);
    if (!parsed || !parsed.steps.length) return false;

    const container = document.querySelector('#estimated_delivery-block');
    if (!container) return false;

    container.innerHTML = `
      <h3 class="estimated-delivery-heading">
        Estimated Delivery Date <span>${parsed.heading}</span>
      </h3>
      <div class="delivery-steps">
        ${parsed.steps.map(s => createStepHTML(s[0], s[1], s[2])).join('')}
      </div>
    `;

    return true;
  }

  // ✅ FIXED: Uncommented and activated the delivery timeline loader
  // const cartLoadinterval = setInterval(() => {
  //   if (renderDeliveryTimeline()) {
  //     clearInterval(cartLoadinterval);
  //   }
  // }, 200);

  // Also trigger on cart updates
  // document.addEventListener('cart:updated', renderDeliveryTimeline);
  // document.addEventListener('afterCartChanged', renderDeliveryTimeline);


  //  Check ETA DELIVERY. : 
  function checkETACartLine() {
    document.querySelectorAll('.cart-items tr.cart-item').forEach((item) => {
      // Find addon/order estimation label safely
      const orderDt = item.querySelector(
        '.cart-item__details dl .product-option dt'
      );

      if (!orderDt) return;

      const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

      // Match your addon condition
      if (/order estimation/i.test(text)) {
        item.classList.add('eta-delivery');
      } else {
        item.classList.remove('eta-delivery');
      }
    });
  }

  /* ---- Run once cart exists ---- */
  const addonCheckInterval = setInterval(() => {
    const cartExists = document.querySelector(
      '.cart-drawer, cart-drawer-items, form.cart__contents .cart-items'
    );

    if (cartExists) {
      clearInterval(addonCheckInterval);
      checkETACartLine();
    }
  }, 200);

  /* ---- Re-run on cart updates (important for AJAX carts) ---- */
  document.addEventListener('cart:updated', checkETACartLine);
  document.addEventListener('afterCartChanged', checkETACartLine);

});

